/**
 * Controller: RolesRemoveModal
 */
angular.module('acme.view.application.roles.removeModal.controllers', [])
.controller('RolesRemoveModalController', [ '$scope', '$uibModalInstance', 'currentRole', function ($scope, $uibModalInstance, currentRole) {

    $scope.errors = [];

    $scope.model = {
      id: currentRole.id,
      name: currentRole.name,
      displayName: currentRole.displayName
    };

    $scope.init = function() {

    };

    $scope.hasErrors = function() {
      return ($scope.errors.length > 0);
    };

    $scope.done = function() {
      $scope.success();
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      $uibModalInstance.close(true);
    };

    $scope.init();

  }]);